/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/11/2020
 */

import DbBaseObject from '@shared/DbBaseObject.js';
import {Type} from "class-transformer";
import FunnelColumnItem from "./FunnelColumnItem";

import ClientProfile from "@shared/Profile/ClientProfile";



export default class OldFunnelItem extends DbBaseObject{


	title: string = ""

	@Type(() => FunnelColumnItem)
	stages: FunnelColumnItem[] = []



	constructor() {
		super();
	}

	findClientProfileById(clientProfileId: string){
		let index = this.findClientProfileIndexById(clientProfileId)
		if(index){
			return this.stages[index.i]._entryArray[index.j].clientProfile
		}
	}
	findStageByClientProfileId(clientProfileId: string){
		let index = this.findClientProfileIndexById(clientProfileId)
		if(index){
			return this.stages[index.i]
		}
	}
	findStageByClientEmail(clientEmail: string){
		let index = this.findClientProfileIndexByEmail(clientEmail)
		if(index){
			return this.stages[index.i]
		}
	}

	updateClientProfile(clientProfile: ClientProfile){
		let index = this.findClientProfileIndexById(clientProfile.id)
		if(index){
			this.stages[index.i]._entryArray[index.j].clientProfile = clientProfile
		}
	}
	addClientProfile(clientProfile: ClientProfile, stageId: string, indexShift = 0){
		let index = this.findClientProfileIndexById(clientProfile.id)
		let stageLocal = this.findStageByStageId(stageId)
		if(stageLocal){
			if(index){
				this.stages[index.i]._entryArray.splice(index.j, 1)
			}
			let funnelEntry = stageLocal.createFunnelEntry()
			funnelEntry.clientProfile = clientProfile
			funnelEntry.index += indexShift
			stageLocal._entryArray.unshift(funnelEntry)
			return funnelEntry
		}
	}

	deleteClientProfile(clientProfile: ClientProfile){
		let index = this.findClientProfileIndexById(clientProfile.id)
		console.log("deleteClientProfile: clientProfile = ", clientProfile, ", index = ", index)
		if(index){
			return this.stages[index.i]._entryArray.splice(index.j, 1)[0]
		}
	}

	updateStage(stage: FunnelColumnItem){
		let index = this.findStageIndexByStageId(stage.id)
		if(index >= 0){
			// Vue.set(this.stages, index, stage)
			this.stages[index] = stage
		}
	}

	addStage(stage: FunnelColumnItem){
		this.stages.push(stage)
	}

	deleteStage(stage: FunnelColumnItem){
		let index = this.findStageIndexByStageId(stage.id)
		if(index >= 0){
			this.stages.splice(index, 1)
		}
	}


	findStageByStageId(stageId){
		return this.stages.find(stage => stage.id === stageId)
	}
	findStageIndexByStageId(stageId){
		return this.stages.findIndex(stage => stage.id === stageId)
	}

	getClientByIndex(index){
		return this.stages[index.i]._entryArray[index.j].clientProfile
	}

	findClientProfileIndexByIdOrEmail(clientProfileId, email){
		let index = this.findClientProfileIndexById(clientProfileId)
				 || this.findClientProfileIndexByEmail(email)

		let clientProfile = index ? this.getClientByIndex(index) : null

		return clientProfile
	}

	findClientProfileIndexById(clientProfileId){
		let j = -1;
		let i = this.stages.findIndex(stage => {
			let index = stage.findClientProfileIndexById(clientProfileId)
			if(index >= 0){
				j = index;
				return true
			}
			return false
		})
		return j >= 0 ? {i, j} : null
	}
	findClientProfileIndexByEmail(clientEmail){
		let j = -1;
		let i = this.stages.findIndex(stage => {
			let index = stage.findClientProfileIndexByEmail(clientEmail)
			if(index >= 0){
				j = index;
				return true
			}
			return false
		})
		return j >= 0 ? {i, j} : null
	}


}



